<script setup>
import icons from '@/assets/icon'

const listeners = useListeners()
const props = defineProps({
  type: String,
  raw: Boolean, // 显示原始颜色
  up: Boolean, // 文字+图标，图标偏下，设置up图标上提
  iconStyle: Object,
})

const classMap = computed(() => ({
  'nio-icon': true,
  'nio-inherit': !props.raw,
  'nio-up': props.up
}))
</script>

<template>
  <i
    :class="classMap"
    v-if="icons[type]"
    v-html="icons[type]"
    v-on="listeners"
    :style="iconStyle||{}"
  />
</template>

<style lang="scss" scoped>
.nio-icon {
  @include flex-center;
  width: 1em;
  height: 1em;
  vertical-align: middle;
  fill: currentColor;

  :deep(svg) {
    width: 100%;
    height: 100%;
  }

  // 强制继承色值
  &.nio-inherit :deep(svg) {
    fill: inherit;

    path {
      fill: inherit;
    }
  }

  &.nio-up {
    transform: translate(0, -8%);
  }
}
</style>
